import { render, staticRenderFns } from "./detailStatistics.vue?vue&type=template&id=14858776"
import script from "./detailStatistics.vue?vue&type=script&lang=js"
export * from "./detailStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports